<template>
  <div id="contactsView" class="vx-card">
    <vcl-facebook secondary="#ff9f43" v-if="loading"></vcl-facebook>
    <ticket-popup v-if="supportTicketPopupParent" :supportTicketPopupProp="supportTicketPopupParent" :customerIdProp="selectedCustomerId" @supportTicketPopupClosed="SupportTicketPopupClosed($event)"></ticket-popup>
    <reconcile v-if="reconcilePopupParent" :reconcilePopupProp="reconcilePopupParent" :customerIdProp="customerIdProp" @ReconcilePopupClosedChildEmit="ReconcilePopupClosedParentEmitCatch($event)"></reconcile>
    <div v-if="!loading">
      <VuePerfectScrollbar class="technic-scroll-area" :settings="settings">
        <div id="user-data" v-if="viewData">
          <div class="vx-row" style="margin: 20px 0px 50px 30px;">
            <div class="vx-row">
              <h4 class="mt-2">
                <div class="vx-col">
                  Müşteri Bilgileri
                </div>
                <div class="vx-col mt-3">
                  <a
                    class="danger"
                    href="#"
                    @click.stop="
                      reconcilePopupParent = true;
                      customerIdProp = customerId;
                    "
                    style="margin-top: 5px; margin-right: 5px;"
                    ><b>Reconcile</b></a
                  >

                  <a :href="'../CustomerAccountWatch/' + customerId" style="margin-top: 5px; color: #e53935;" target="_blank"><b style="white-space: nowrap;">Hesap Bilgileri</b></a>
                  <a :href="'/AccountMovementWatchByCustomerId/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #00acc1;" target="_blank"><b style="white-space: nowrap;">Hesap Hareketleri</b></a>
                  <a :href="'/SaleByCustomerId/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #3949ab;" target="_blank"><b>Satış</b></a>
                  <a :href="'/MoneyTransferByCustomerId/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #546e7a;" target="_blank"><b>Transfer</b></a>
                  <a :href="'/IncomeByCustomerId/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #00897b;" target="_blank"><b>Ödeme</b></a>
                  <a :href="'/GarageByCustomerId/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #fb8c00;" target="_blank"><b>Garaj</b></a>
                  <a :href="'/TechnicByCustomerId/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #43a047;" target="_blank"><b>Teknik</b></a>
                  <a
                    href="#"
                    class="success"
                    @click.stop="
                      supportTicketPopupParent = true;
                      selectedCustomerId = customerId;
                    "
                    style="margin-left: 15px; margin-top: 5px;"
                    ><b>Destek Kaydı</b></a
                  >
                  <a :href="'/SaleWizardWithCustomerId/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #7cb342;" target="_blank"><b>Sipariş Oluştur</b></a>
                  <a :href="'/SubscriptionSystem/' + customerId" style="margin-left: 15px; margin-top: 5px; color: #6d4c41;" target="_blank"><b>Abonelikler</b></a>
                </div>
              </h4>
            </div>
          </div>

          <!-- Avatar -->

          <div class="vx-row">
            <!-- Avatar Col -->
            <div class="vx-col ml-5" id="avatar-col">
              <div class="img-container mb-4">
                <img :src="viewData.avatar ? viewData.avatar : this.$defaultPicture" class="rounded w-full" />
              </div>
            </div>

            <!-- Information - Col 1 -->
            <div class="vx-col flex-1">
              <table>
                <tr>
                  <td class="font-semibold">Adı Soyadı:</td>
                  <td :class="viewData.firstName_span ? 'bg-warning p-3' : ''">
                    <span v-html="viewData.firstName"></span>
                    <span v-if="viewData.firstName_span" class="danger"><b>&nbsp;(Kendisiyle iletişim kurulmasını istemiyor)</b></span>
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Telefon:</td>
                  <td class="flex items-center">
                    <a :href="'tel:' + viewData.phone" class="flex items-center mr-5">{{ viewData.phone }}</a>
                    <a :href="'https://wa.me/' + viewData.phone" class="flex items-center" target="_blank">
                      <svg :style="whatsappStyle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
                        <path :d="whatsappIcon" fill-rule="evenodd" />
                      </svg>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Email:</td>
                  <td>
                    <a v-if="viewData.email" v-bind:href="'mailto:' + viewData.email">{{ viewData.email }}</a>
                    <span v-if="!viewData.email">
                      Email hesabı kaydedilmemiş
                      <div class></div>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Üyelik Tarihi:</td>
                  <td>
                    {{ viewData.createdDate.replace("T", " ").substr(0, 16) }}
                  </td>
                </tr>
              </table>
            </div>
            <div class="vx-col flex-1" id="account-info-col-2">
              <table>
                <tr>
                  <td class="font-semibold">TC:</td>
                  <td>{{ viewData.taxNumber ? viewData.taxNumber : "TC girilmemiş" }}</td>
                </tr>
                <!-- <tr>
                  <td class="font-semibold">Müşteri Temsilcisi:</td>
                  <td>{{ viewData.addUserID }}</td>
                </tr> -->
                <tr>
                  <td class="font-semibold">İl:</td>
                  <td>
                    {{ viewData.billingCityName ? viewData.billingCityName : "İl kaydedilmemiş." }}
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Etiket:</td>
                  <td>
                    <span v-for="(row, i) in JSON.parse(viewData.tags)" :key="i" style="color: red;">
                      {{ row.value }}
                    </span>
                  </td>
                </tr>
                <!-- <tr>
                  <td class="font-semibold">Müşteriye Puanınız:</td>
                  <td>
                    <star-rating @rating-selected="setRating" :rating="3" :star-size="20"></star-rating>
                  </td>
                </tr> -->
                <tr>
                  <td class="font-semibold">Pazaryeri Müşterisi:</td>
                  <td>{{ viewData.isOnlineCustomer ? "Evet" : "Hayır" }}</td>
                </tr>
                <!-- <tr>
                  <td class="font-semibold">Plaka kodu:</td>
                  <td>
                    {{ viewData.billingCity ? viewData.billingCity : "Plaka yok" }}
                  </td>
                </tr> -->
                <tr>
                  <td class="font-semibold">Adres:</td>
                  <td>{{ viewData.address ? viewData.address : "Adres Bulunamadı" }}</td>
                </tr>
              </table>
            </div>

            <div class="vx-row">
              <div>
                <div v-if="!viewData.isKVKKApproved" style="margin-right: 150px;">
                  <div class="vx-col">
                    <vs-button icon-pack="feather" icon="icon-message-square" class="flex items-center" @click="sendCustomerKVKKSmsCode" color="primary" type="filled"> KVKK SMS Gönder</vs-button>
                  </div>
                  <div class="vx-col mt-5">
                    <vs-input style="width: 175px;" placeholder="KVKK Onay Kodu Giriniz" v-model="viewData.kVKKSmsCode" />
                  </div>
                  <div class="vx-col mt-5">
                    <vs-button icon-pack="feather" icon="icon-save" class="flex items-center" @click="checkCustomerKVKKSmsCode" color="success" type="filled"> KVKK Onay Kod Gir</vs-button>
                  </div>
                </div>

                <div v-else class="vx-col mr-10">
                  <vs-checkbox :disabled="1" class="mb-5" v-model="viewData.isKVKKApproved">KVKK Onay Alınmış</vs-checkbox>
                  <label class="text-sm mb-1"><b>Kvkk Personel</b></label>
                  <v-select name="KvkkAlanPersonel" disabled v-model="viewData.kvkkApproveUserId" placeholder="Personel" :options="userListKvkk" label="userName" class="select" :reduce="(row) => row.userId">
                    <span slot="no-options">Eşleşen Veri Yok</span>
                  </v-select>
                </div>
              </div>
            </div>

            <!-- KVKK SMS ONAYI-->

            <!-- Information - Col 2 -->

            <!-- /Information - Col 2 -->
            <!-- <div class="vx-col justify-end w-full flex" id="account-manage-buttons">
              <vs-button
                icon-pack="feather"
                icon="icon-edit"
                class="mr-4"
                :to="{
                  name: 'contactsEdit',
                  params: { contactsId: $route.params.contactsId },
                }"
                >Düzenle</vs-button
              >

              <vs-button color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord()">Sil</vs-button>
            </div> -->
          </div>
          <!-- 
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex items-end px-3">
                    <feather-icon svgClasses="w-6 h-6" icon="PhoneCallIcon" class="mr-2" />
                    <span class="font-medium text-lg leading-none">İletişim Bilgileri</span>
                  </div>
                  <vs-divider />
                </div>
              </div>
              <table style="margin-left: 10px;">
                <tr>
                  <td class="font-semibold">Dil:</td>
                  <td>Müşteri dili belirlenmemis.</td>
                </tr>
                <tr>
                  <td class="font-semibold">Telefon(2):</td>
                  <td>
                    {{ viewData.other && viewData.other[1] ? "+" + viewData.other[1].prefix + " " + viewData.other[1].value : "2.Telefonu kaydedilmemiş." }}
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Teslimat Adresi:</td>
                  <td>
                    {{ viewData.address ? viewData.address : "Teslimat adres bilgisi kaydedilmemiş." }}
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Fatura Adresi:</td>
                  <td>
                    {{ viewData.billingAddress ? viewData.billingAddress : "Fatura adres bilgisi kaydedilmemiş." }}
                  </td>
                </tr>
              </table>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex items-end px-3">
                    <feather-icon svgClasses="w-6 h-6" icon="CreditCardIcon" class="mr-2" />
                    <span class="font-medium text-lg leading-none">Hesap Bilgileri ve Yorumlar</span>
                  </div>
                  <vs-divider />
                </div>
              </div>
              <table>
                <tr>
                  <td class="font-semibold">Vergi No:</td>
                  <td>
                    {{ viewData.taxNumber > !1 ? viewData.taxNumber : "Vergi numarası kaydedilmemiş." }}
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Vergi Dairesi:</td>
                  <td>
                    {{ viewData.taxName != null ? viewData.taxName : "Vergi dairesi kaydedilmemiş." }}
                  </td>
                </tr>

                <tr>
                  <td class="font-semibold">Müşteri Genel Puanı:</td>
                  <td>{{ viewData.stars }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Not:</td>
                  <td>
                    Müşteri hakkında yorumlar için aksiyonlar panelini kullanabilirsiniz.
                  </td>
                </tr>
              </table>
            </div>
          </div> -->
          <div class="flex justify-center" style="margin-bottom: -35px; margin-top: 25px; margin-left: 100px;">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              color="#00ACC1"
              class="mr-4"
              :to="{
                name: 'ContactsEdit',
                params: { contactsId: $route.params.contactsId },
              }"
              >Düzenle</vs-button
            >
          </div>
          <div class="block overflow-x-auto">
            <vs-table search noDataText="Hiç Mesaj Yok" :data="viewData.messages">
              <template slot="header">
                <div class="flex items-end items-center px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="VoicemailIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none mr-10">Müşteri Aksiyonları</span>
                  <add-message :customerId="customerId" @completed="addNoteResponse"></add-message>
                </div>
              </template>
              <template slot="thead">
                <vs-th style="width: 200px;">Tarih</vs-th>
                <vs-th>Bildirim Gönder</vs-th>
                <vs-th>Kullanıcı</vs-th>
                <vs-th>Mesaj</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :stripe="true" v-for="(tr, i) in data" :key="i">
                  <vs-td>{{ tr.createdDate.replace("T", " ").substr(0, 19) }}</vs-td>
                  <vs-td class="">
                    <vs-button icon-pack="feather" icon="icon-bell" class="flex items-center" @click="openNotificationPopup(tr)" color="primary" type="filled"> Bildirim Gönder</vs-button>
                  </vs-td>
                  <vs-td>{{ tr.user }}</vs-td>
                  <vs-td>{{ tr.message }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <div v-if="1 == 2" class="block overflow-x-auto">
            <vs-table search noDataText="Hiç Alışveriş Yok" :data="prevTrades">
              <template slot="header">
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="BookOpenIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Geçmiş Alışverişler</span>
                </div>
              </template>
              <template slot="thead">
                <vs-th style="width: 500px;">Ürün</vs-th>
                <vs-th>Seri No</vs-th>
                <vs-th>Adet</vs-th>
                <vs-th>Hareket Türü</vs-th>
                <vs-th>Tarih</vs-th>
                <vs-th>Depo</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :state="tr.quantity < 0 ? 'danger' : 'success'" id="profile-connection" :stripe="true" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ tr.product }}</vs-td>
                  <vs-td>{{ tr.serialNumber }}</vs-td>
                  <vs-td>{{ Math.abs(tr.quantity) }}</vs-td>
                  <vs-td>{{ tr.actionType }}</vs-td>
                  <vs-td>{{ tr.createdDate.substr(0, 10) }}</vs-td>
                  <vs-td>{{ tr.warehouse }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div class="centerx">
      <vs-popup classContent="popup-example" title="Bildirim Gönder" :active.sync="displaySendMessage">
        <label class="text-sm">Kullanıcıya gönderilecek mesaj</label>
        <vs-input class="w-full mb-4 mt-1" v-model="lastMessage" />
        <label class="text-sm">Personel Seçiniz</label>
        <vs-select class="w-full mb-4 mt-1" v-model="notificationUser" autocomplete>
          <vs-select-item :key="index" :value="item.id" :text="item.value" v-for="(item, index) in userList" />
        </vs-select>
        <div class="vx-row">
          <div class="vx-col md:w-2/3 w-full">
            <label class="text-sm">Bildirim yapılacak ürünü seçiniz</label>
            <vs-input type="number" class="w-full mt-1" size="medium" v-model="notificationProduct.productId" />
          </div>
          <div class="vx-col mt-5">
            <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
            <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
          </div>
        </div>

        <vs-button class="mt-5" @click="sendMessage" color="primary" type="filled">Gönder</vs-button>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import StarRating from "vue-star-rating";
import addMessage from "./addMessage.vue";
import { VclFacebook } from "vue-content-loading";
import vSelect from "vue-select";
import TicketPopup from "../SupportTicket/TicketPopup.vue";
import Reconcile from "../Account/Reconcile";
import ProductSearch from "../Search/ProductSearch.vue";

export default {
  components: {
    vSelect,
    StarRating,
    VuePerfectScrollbar,
    addMessage,
    VclFacebook,
    TicketPopup,
    Reconcile,
    ProductSearch,
  },
  data() {
    return {
      productSearchPopupParent: false,
      reconcilePopupParent: false,
      customerIdProp: null,
      supportTicketPopupParent: false,
      selectedCustomerId: null,
      name: "ContactsView",
      lastMessage: "",
      displaySendMessage: false,
      loading: true,
      customerId: this.$route.params.customerId,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      notificationUser: "",
      notificationProduct: {},
      userList: [],
      userListKvkk: [],
      viewData: [],
      prevTrades: [],
      whatsappStyle: {
        width: "25px",
        height: "25px",
        background: "#4dc247",
        fill: "white",
        borderRadius: "50%",
        padding: "2px",
      },
      whatsappIcon:
        "M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z",
      whatsapp: {
        link: "",
        visible: false,
        value: Number,
        text: "",
      },
      phone: {
        link: "",
        visible: false,
        value: Number,
        text: "",
      },
    };
  },
  watch: {
    notification() {
      this.displayPromptIfNotification();
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.userData.userId;
    },
    beautifyAmount() {
      if (this.viewData.realAmount) {
        let str = "";
        if (this.viewData.realAmount[0].IO == "I") {
          str = "Tedarikçi: " + this.viewData.realAmount[0].amount + this.viewData.realAmount[0].currency;
        }

        if (this.viewData.realAmount[0].IO == "O") {
          str += "Müşteri: " + this.viewData.realAmount[0].amount + this.viewData.realAmount[0].currency;
        }
        return str;
      }
    },
  },

  methods: {
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      console.log("test", v);
      console.log("deneme", this.notificationProduct);
      if (v) {
        this.notificationProduct.product = v.productName;
        this.notificationProduct.productId = v.productId;
      } else {
        this.notificationProduct = null;
      }
      console.log("deneme11", this.notificationProduct);
      console.log("dd", this.notificationProduct.product);
      console.log("ss", this.notificationProduct.productId);
    },
    ReconcilePopupClosedParentEmitCatch: async function (v) {
      this.reconcilePopupParent = false;
    },

    SupportTicketPopupClosed: async function (v) {
      this.supportTicketPopupParent = false;
      console.log("child is closed", v);
    },
    displayPromptIfNotification() {
      let x = this.notification;
      if (x != null && x.name == this.name && parseInt(x.id) > 0) {
        this.$store.commit("PUSH_NOTIFICATION_TO_COMPONENT", null);
      }
    },
    sendMessage() {
      repository
        .postEntity("General/pushNotification", {
          title: "Özel Mesaj",
          subject: " ( " + this.notificationProduct.product + " - Id = " + this.notificationProduct.productId + " ) ",
          message: this.lastMessage + "<br/> <br/> ( Bildirim ile ilgili bahsi geçen ürün " + " <strong>" + this.notificationProduct.product + " Id = " + this.notificationProduct.productId + " </strong> )",
          icon: "233",
          time: new Date(),
          category: "2",
          from: this.currentUser,
          to: this.notificationUser,
          link: '{"name":"ContactsView", "paramName":"customerId","id":"' + this.$route.params.customerId + '"}',
        })
        .then((r) => {
          if (r && r.isSuccessful) {
            this.$vs.notify({
              title: "Başarılı",
              text: `Mesajınız gönderildi`,
              color: "success",
            });
            this.displaySendMessage = false;
          } else {
            this.$vs.notify({
              title: "Mesaj gönderme hatası",
              text: `${(r && r.exceptionMessage) || "Bilinmeyen hata"}`,
              color: "danger",
              icon: "warning",
            });
          }
        });
    },

    sendCustomerKVKKSmsCode() {
      repository
        .postEntity("Customer/sendCustomerKVKKSmsCode", {
          customerId: this.customerId,
          phoneNumber: this.viewData.phone,
        })
        .then((r) => {
          if (r && r.isSuccessful) {
            this.$vs.notify({
              title: "Başarılı",
              text: `Mesajınız gönderildi`,
              color: "success",
            });
            this.displaySendMessage = false;
          } else {
            this.$vs.notify({
              title: "Mesaj gönderme hatası",
              text: `${(r && r.exceptionMessage) || "Bilinmeyen hata"}`,
              color: "danger",
              icon: "warning",
            });
          }
        });
    },

    checkCustomerKVKKSmsCode() {
      repository
        .postEntity("Customer/checkCustomerKVKKSmsCode", {
          customerId: this.customerId,
          kVKKSmsCode: this.viewData.kVKKSmsCode,
        })
        .then((r) => {
          if (r && r.isSuccessful) {
            this.$vs.notify({
              title: "Başarılı",
              text: `KVKK onay alındı`,
              color: "success",
            });
            this.viewData.isKVKKApproved = true;
          } else {
            this.$vs.notify({
              title: "Mesaj gönderme hatası",
              text: `${(r && r.exceptionMessage) || "Bilinmeyen hata"}`,
              color: "danger",
              icon: "warning",
            });
          }
        });
    },

    openNotificationPopup(tr) {
      this.lastMessage = tr.message;
      this.displaySendMessage = true;
    },
    addNoteResponse(r) {
      if (r.response) {
        this.viewData.messages.unshift(r.data);
      }
    },

    setRating: function (rating) {
      this.$vs.notify({
        title: "Müşteri Yıldızları",
        text: `Müşteriye ${rating} puan verildi.`,
      });
    },
    getUsers: async function () {
      this.userListKvkk = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Silme İşlemi`,
        text: `"${this.viewData.name}" Silmek istediğinize emin misiniz?`,
        accept: this.deleteRecord,
        acceptText: "Sil",
        cancelText: "Vazgeç",
      });
    },
    deleteRecord: async function () {
      //repository.deleteEntity("User/deleteUser", this.viewData.uId);

      //this.$router.push("/userList");
      this.$vs.notify({
        color: "warning",
        title: "Bu Özellik Şuanda Kullanılmıyor",
      });
    },
    getUserList: async function () {
      let r = await repository.getAll("User/getUserListForTag");
      if (r && r.list) {
        this.userList = r.list;
      }
    },
    getCustomer: async function (customerId) {
      this.viewData = await repository.getById("Customer/getById", customerId);
      this.prevTrades = await repository.getById("Customer/getProductList", customerId);
      if (!(this.viewData && this.viewData.isSuccessful)) {
        this.$vs.notify({
          title: "Hata",
          text: "Müşteri bilgilerine erişilemedi",
          color: "danger",
          icon: "warning",
        });
        return;
      }
      if (!(this.prevTrades && this.prevTrades.isSuccessful)) {
        this.$vs.notify({
          title: "Hata",
          text: "Önceki alışveriş bilgilerine erişilemedi",
          color: "danger",
          icon: "warning",
        });
        return;
      }

      this.viewData = this.viewData.list[0];
      this.prevTrades = this.prevTrades.list;
      this.viewData = repository.convertToJSON(this.viewData, "messages");
      this.viewData = repository.convertToJSON(this.viewData, "realAmount");

      let fn = this.viewData.firstName;
      let span = fn.indexOf("</span>");
      if (span > 0) {
        this.viewData.firstName_span = fn.substr(0, span + 7);
        this.viewData.firstName = fn.substr(span + 7).trim();
      }
      this.loading = false;
    },

    fillWhatsapp_old(c) {
      if (!(c.other && Array.isArray(c.other) && c.other.length > 0)) c = repository.convertToJSON(c, "other");
      if (c.other && Array.isArray(c.other) && c.other.length > 0) {
        for (let i = 0; i < c.other.length; i++) {
          let cp = c.other[i];
          if (cp.isWhatsapp) {
            let full = "";
            if (cp.value)
              if (cp.prefix && cp.prefix > 0) {
                full = (cp.prefix.toString() + cp.value.toString()).replace(/[\s\n\r]+/g, "");
              } else {
                full = cp.value;
              }
            if (full && full.length > 0) {
              let x = parseInt(full);
              this.whatsapp = {
                visible: true,
                text: "+" + full,
                link: "https://wa.me/" + full,
                value: isNaN(x) ? 0 : x,
              };
            }
            break;
          }
        }
      } else {
        if (c.phone) {
          let phone = c.phone.toString();
          if (phone.substr(0, 2) == "90") {
            if (phone[2] == "5") {
              this.whatsapp = {
                visible: true,
                text: "+" + phone,
                link: "https://wa.me/" + phone,
                value: isNaN(phone) ? 0 : phone,
              };
            }
          } else {
            if (phone.length == 10) {
              if (phone[0] == "5") {
                let full = "90" + phone;
                this.whatsapp = {
                  visible: true,
                  text: "+" + full,
                  link: "https://wa.me/" + full,
                  value: isNaN(full) ? 0 : full,
                };
              }
            } else {
              this.whatsapp = {
                visible: true,
                text: "+" + phone,
                link: "https://wa.me/" + phone,
                value: isNaN(phone) ? 0 : phone,
              };
            }
          }
        }
      }
    },
  },
  created: async function () {
    await this.getUsers();
    Promise.all([this.getUserList(), this.getCustomer(this.customerId)]);
  },
};
</script>

<style lang="scss" scoped>
.vx-card {
  margin-top: 60px !important;
}
#contactsView {
  .mt-2 {
    .a {
    }
  }
  .vs-table--content {
    height: 200px;
    th,
    td {
      height: 40px !important;
    }
  }
  .vue-star-rating-rating-text {
    display: none;
  }
  #avatar-col {
    width: 10rem;
  }
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  }
  .amount-container {
    margin-bottom: 5px;
  }
  .amount {
    margin-right: 10px;
    font-weight: bolder;
  }
  .amount.red {
    color: red;
  }
}
</style>

<style lang="scss">
.select {
  width: 150px;

  .vs__actions {
    display: none;
  }
}
</style>
